import { Divider, Typography } from 'antd'
import React from 'react'
import BinWashing from '../../../components/Wash/BinWashing/BinWashing'

const BinWashingPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Washing Bin
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <BinWashing userData={userData} />
    </>
  )
}

export default BinWashingPage